import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';

import { FormField } from '../../../shared/components/forms/form-field';
import { TextInput } from '../../../shared/components/forms/text-input';
import { FeedPage } from './feed-page';

/** "Feed" card shared by every feed page: Name (with the 409 name-taken
 *  error, cleared on edit) and the optional Location label. `bare` renders
 *  just the fields (no card or title), for a feed page's General tab. */
@Component({
  selector: 'app-feed-basics-card',
  standalone: true,
  imports: [FormsModule, TranslocoDirective, FormField, TextInput],
  template: `
    <ng-container *transloco="let t; read: 'providers.feedPage'">
      <div [class]="bare() ? '' : 'rounded-card bg-card p-6 shadow-hairline'">
        @if (!bare()) {
          <div class="mb-5 font-display text-[12px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.feed') }}</div>
        }
        <div class="flex max-w-[420px] flex-col gap-5">
          <app-form-field [label]="t('fields.name')" [help]="t('fields.nameHelp')" [error]="page.nameTaken() ? t('fields.nameTaken') : null">
            <app-text-input
              [ngModel]="page.name()"
              (ngModelChange)="page.name.set($event); page.nameTaken.set(false)"
              [ngModelOptions]="{ standalone: true }"
              required
            ></app-text-input>
          </app-form-field>
          <app-form-field [label]="t('fields.locality') + ' (' + t('fields.localityOptional') + ')'" [help]="t('fields.localityHelp')">
            <app-text-input
              [ngModel]="page.locality()"
              (ngModelChange)="page.locality.set($event)"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="t('fields.localityPlaceholder')"
            ></app-text-input>
          </app-form-field>
        </div>
      </div>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedBasicsCardComponent {
  protected readonly page = inject(FeedPage);
  /** Fields only, without the card wrapper and title. */
  readonly bare = input(false);
}
